module.exports = __webpack_public_path__ + "static/media/3_nature.5ee670cc.jpg";